export type AirConditioningTypesProps = {
  hasAny: boolean;
  hasCentral: boolean;
  hasWall: boolean;
  hasWindow: boolean;
};

const AirConditioningTypes = ({
  hasAny = false,
  hasCentral = false,
  hasWall = false,
  hasWindow = false,
}: Partial<AirConditioningTypesProps> = {}): AirConditioningTypesProps => ({
  hasAny: Boolean(hasAny),
  hasCentral: Boolean(hasCentral),
  hasWall: Boolean(hasWall),
  hasWindow: Boolean(hasWindow),
});

export default AirConditioningTypes;
